/**
 * Lynden Hardware v2 DEV — mockup header chrome
 * ONLY on unpublished preview theme (loaded from DEV theme.liquid).
 *
 * Hides Impact announcement / header / theme-breadcrumb and injects:
 *   1) static trustbar
 *   2) mockup header (logo, centered nav + dropdowns, icons)
 *   3) mobile drawer with accordion sub-categories
 */
(function () {
  var MARK = "lyd-hv2-chrome";
  var ROOT_ID = "lyd-hv2-chrome-root";
  var OPEN_DELAY = 90;
  var CLOSE_DELAY = 160;

  /**
   * Top-level nav + sub-categories.
   * Intentionally curated brand/type pages (not every SEO/leaf collection —
   * e.g. skips "10ml Liquids>…>…" auto-handles). Expand when new brands launch.
   */
  var NAV = [
    {
      label: "E-Zigaretten",
      href: "/collections/e-zigaretten",
      children: [
        { label: "Alle E-Zigaretten", href: "/collections/e-zigaretten", all: true },
        { label: "Lynden", href: "/collections/lynden-e-zigaretten" },
        { label: "Uwell", href: "/collections/uwell-e-zigaretten" },
        { label: "Geekvape", href: "/collections/geekvape-e-zigaretten" },
        { label: "Vaporesso", href: "/collections/vaporesso-e-zigaretten" },
        { label: "Flerbar", href: "/collections/flerbar-e-zigaretten" },
        { label: "GOBAR", href: "/collections/e-zigaretten-gobar" },
        { label: "Joyetech", href: "/collections/e-zigaretten-joyetech" },
        { label: "Justfog", href: "/collections/justfog-e-zigaretten" },
        { label: "Lost Vape", href: "/collections/e-zigaretten-lost-vape" },
        { label: "VooPoo", href: "/collections/voopoo-e-zigaretten" },
        { label: "Oxva", href: "/collections/oxva-e-zigaretten" },
        { label: "IVG", href: "/collections/ivg-e-zigaretten" },
        { label: "SKE", href: "/collections/ske-e-zigaretten" },
        { label: "KTS", href: "/collections/kts-e-zigaretten" },
        { label: "Revoltage", href: "/collections/revoltage-e-zigaretten" },
        { label: "Smok", href: "/collections/e-zigaretten-smok" },
        { label: "Vaptio", href: "/collections/vaptio-e-zigaretten" },
        { label: "Einweg", href: "/collections/einweg-e-zigaretten" },
        { label: "Cap-Systeme", href: "/collections/e-zigaretten-cap-systeme" },
        { label: "Basic", href: "/collections/e-zigaretten-basic" },
        { label: "Sale E-Zigaretten", href: "/collections/sale-e-zigaretten" },
      ],
    },
    {
      label: "Depots",
      href: "/collections/lynden-premium-depots",
      children: [
        { label: "Alle Depots", href: "/collections/lynden-premium-depots", all: true },
        { label: "Lynden Premium Depots", href: "/collections/lynden-premium-depots" },
      ],
    },
    {
      label: "Pods",
      href: "/collections/pods",
      children: [
        { label: "Alle Pods", href: "/collections/pods", all: true },
        { label: "Prefilled Pods", href: "/collections/prefilled-pods" },
        { label: "Leer-Pods", href: "/collections/leer-pods" },
        { label: "Caps & Pods", href: "/collections/caps-pods" },
        { label: "Elfbar Pods", href: "/collections/elfbar-pods" },
        { label: "Uwell Pods", href: "/collections/uwell-pods" },
        { label: "Geekvape Pods", href: "/collections/geekvape-pods" },
        { label: "Vaporesso Pods", href: "/collections/vaporesso-pods" },
        { label: "IVG Pods", href: "/collections/ivg-pods" },
        { label: "Justfog Pods", href: "/collections/justfog-pods" },
      ],
    },
    {
      label: "Liquids",
      href: "/collections/liquids",
      children: [
        { label: "Alle Liquids", href: "/collections/liquids", all: true },
        {
          label: "Liquid Finder",
          href: "/pages/liquid-finder?system=dtl",
          tool: true,
        },
        { label: "Beliebteste", href: "/collections/die-beliebtesten-liquids" },
        { label: "Lynden Liquids", href: "/collections/lynden-liquids" },
        { label: "InnoCigs", href: "/collections/innocigs-liquids" },
        { label: "Vampire Vape", href: "/collections/vampire-vape-liquid" },
        { label: "Dinner Lady", href: "/collections/dinner-lady-liquids" },
        { label: "SC Liquid", href: "/collections/sc-liquid" },
        { label: "FlavourArt", href: "/collections/flavourart-liquids" },
        { label: "Happy Liquid", href: "/collections/happy-liquid-liquids" },
        { label: "Shadow Burner", href: "/collections/shadow-burner-liquids" },
        { label: "Das ist Dampfen", href: "/collections/das-ist-dampfen-liquids" },
        { label: "Vincent dans les Vapes", href: "/collections/vincent-dans-les-vapes-liquids" },
      ],
    },
    {
      label: "Nikotinsalz",
      href: "/collections/nikotinsalz-liquids",
      children: [
        { label: "Alle Nikotinsalz", href: "/collections/nikotinsalz-liquids", all: true },
        {
          label: "Liquid Finder",
          href: "/pages/liquid-finder?system=mtl",
          tool: true,
        },
        { label: "ELFLIQ", href: "/collections/elfbar-elfliq-nikotinsalz" },
        { label: "Maryliq", href: "/collections/lost-mary-maryliq-nikotinsalz" },
        { label: "Pod Salt", href: "/collections/pod-salt-nikotinsalz" },
        { label: "IVG", href: "/collections/ivg-nikotinsalz" },
        { label: "Overvape", href: "/collections/overvape-nikotinsalz" },
        { label: "Flerbar", href: "/collections/flerbar-nikotinsalz" },
        { label: "Elux", href: "/collections/elux-nikotinsalz" },
        { label: "Dojoliq", href: "/collections/dojoliq-nikotinsalz" },
        { label: "SC Nikotinsalz", href: "/collections/sc-nikotinsalz" },
        { label: "Twelve Monkeys", href: "/collections/twelve-monkeys-nikotinsalz" },
        { label: "Dr. Frost", href: "/collections/dr-frost-nikotinsalze" },
        { label: "Vampire Vape", href: "/collections/vampire-vape-nikotinsalz" },
        { label: "Linvo", href: "/collections/linvo-nikotinsalz" },
        { label: "5EL", href: "/collections/5el-nikotinsalz" },
        { label: "Riot Squad", href: "/collections/riot-squad-nikotinsalz" },
        { label: "Must Have", href: "/collections/must-have-nikotinsalz" },
        { label: "Salt Club", href: "/collections/salt-club-nikotinsalz" },
        { label: "Revoltage", href: "/collections/revoltage-nikotinsalz" },
        { label: "Nikotinshots", href: "/collections/nikotinshots" },
        { label: "Popdrop Shots", href: "/collections/popdrop-nikotin-shots" },
      ],
    },
    {
      label: "Zubehör",
      href: "/collections/zubehor",
      children: [
        { label: "Alles Zubehör", href: "/collections/zubehor", all: true },
        { label: "Lynden Zubehör", href: "/collections/lynden-zubehor" },
        { label: "Uwell Zubehör", href: "/collections/uwell-zubehoer" },
        { label: "Vaporesso Zubehör", href: "/collections/vaporesso-zubehor" },
        { label: "Justfog Zubehör", href: "/collections/justfog-zubehor" },
        { label: "Geekvape / Clearomizer", href: "/collections/clearomizer-geekvape" },
        { label: "IVG Zubehör", href: "/collections/ivg-zubehor" },
        { label: "Smok Zubehör", href: "/collections/smok-zubehor" },
        { label: "VooPoo Zubehör", href: "/collections/voopoo-zubehor" },
        { label: "Innokin Zubehör", href: "/collections/innokin-zubehor" },
        { label: "Elfbar Zubehör", href: "/collections/zubehor-elfbar-zubehor" },
        { label: "Sonstiges", href: "/collections/sonstiges-zubehor" },
        { label: "Sale Zubehör", href: "/collections/sale-zubehor" },
      ],
    },
    { label: "Angebote", href: "/collections/sale", sale: true },
  ];

  function ready(fn) {
    if (document.readyState === "loading") {
      document.addEventListener("DOMContentLoaded", fn);
    } else {
      fn();
    }
  }

  function mark() {
    try {
      document.documentElement.classList.add(MARK);
      if (document.body) document.body.classList.add(MARK);
    } catch (e) {}
  }

  function hideImpactChrome() {
    var selectors = [
      ".shopify-section--announcement-bar",
      ".shopify-section--header",
      "#shopify-section-header",
      ".shopify-section-group-header-group.shopify-section--header",
      "store-header.header",
      ".shopify-section--breadcrumb",
      ".shopify-section-group-header-group.shopify-section--breadcrumb",
    ];
    selectors.forEach(function (sel) {
      document.querySelectorAll(sel).forEach(function (el) {
        el.style.setProperty("display", "none", "important");
        el.setAttribute("aria-hidden", "true");
      });
    });
  }

  function svg(paths, extraClass) {
    return (
      '<svg viewBox="0 0 24 24" aria-hidden="true"' +
      (extraClass ? ' class="' + extraClass + '"' : "") +
      ">" +
      paths +
      "</svg>"
    );
  }

  var LOGO_FALLBACK =
    "https://www.lynden.de/cdn/shop/files/00_Lynden_Logo_Black.png?v=1708944793&width=280";

  function resolveLogoSrc() {
    var img =
      document.querySelector(
        ".shopify-section--header .header__logo-image:not(.header__logo-image--transparent)"
      ) ||
      document.querySelector(
        "store-header .header__logo-image:not(.header__logo-image--transparent)"
      ) ||
      document.querySelector(".header__logo img") ||
      document.querySelector(
        'img[src*="Lynden_Logo"], img[src*="lynden_logo"], img[src*="Lynden_logo"]'
      );
    if (img) {
      var src =
        img.currentSrc ||
        img.getAttribute("src") ||
        img.getAttribute("data-src") ||
        "";
      if (src) {
        return src.replace(/&amp;/g, "&").replace(/width=\d+/i, "width=280");
      }
    }
    return LOGO_FALLBACK;
  }

  function logoHtml() {
    var src = resolveLogoSrc();
    return (
      '<a class="lyd-hv2-siteheader__logo" href="/" aria-label="LYNDEN Startseite">' +
      '<img class="lyd-hv2-siteheader__logo-img" src="' +
      src +
      '" alt="LYNDEN" width="140" height="40" decoding="async" />' +
      "</a>"
    );
  }

  function navItemHtml(item, idx) {
    var hasKids = item.children && item.children.length;
    var id = "lyd-hv2-nav-panel-" + idx;
    var linkClass =
      "lyd-hv2-siteheader__link" + (item.sale ? " is-sale" : "");
    var chev = hasKids
      ? svg('<path d="M6 9l6 6 6-6"/>', "lyd-hv2-siteheader__chev")
      : "";

    var top =
      '<a class="' +
      linkClass +
      '" href="' +
      item.href +
      '"' +
      (hasKids
        ? ' aria-haspopup="true" aria-expanded="false" aria-controls="' +
          id +
          '"'
        : "") +
      ">" +
      item.label +
      chev +
      "</a>";

    if (!hasKids) {
      return '<div class="lyd-hv2-siteheader__item">' + top + "</div>";
    }

    var mega = item.children.length > 10 ? " is-mega" : "";
    var panel =
      '<ul class="lyd-hv2-siteheader__panel' +
      mega +
      '" id="' +
      id +
      '" role="list">' +
      item.children
        .map(function (c) {
          var cls = [];
          if (c.all) cls.push("is-all");
          if (c.tool) cls.push("is-tool");
          return (
            "<li>" +
            '<a href="' +
            c.href +
            '"' +
            (cls.length ? ' class="' + cls.join(" ") + '"' : "") +
            ">" +
            c.label +
            "</a></li>"
          );
        })
        .join("") +
      "</ul>";

    return (
      '<div class="lyd-hv2-siteheader__item" data-has-panel>' +
      top +
      panel +
      "</div>"
    );
  }

  function drawerHtml() {
    var rows = NAV.map(function (item, idx) {
      var hasKids = item.children && item.children.length;
      var subId = "lyd-hv2-drawer-sub-" + idx;
      var linkClass = item.sale ? ' class="is-sale"' : "";
      var main =
        '<div class="lyd-hv2-drawer__row-main">' +
        '<a href="' +
        item.href +
        '"' +
        linkClass +
        ">" +
        item.label +
        "</a>";

      if (hasKids) {
        main +=
          '<button type="button" class="lyd-hv2-drawer__toggle" aria-expanded="false" aria-controls="' +
          subId +
          '" aria-label="' +
          item.label +
          ' Untermenü">' +
          svg('<path d="M6 9l6 6 6-6"/>') +
          "</button>";
      }
      main += "</div>";

      var subs = "";
      if (hasKids) {
        subs =
          '<ul class="lyd-hv2-drawer__subs" id="' +
          subId +
          '" hidden>' +
          item.children
            .map(function (c) {
              var cls = [];
              if (c.all) cls.push("is-all");
              if (c.tool) cls.push("is-tool");
              return (
                "<li>" +
                '<a href="' +
                c.href +
                '"' +
                (cls.length ? ' class="' + cls.join(" ") + '"' : "") +
                ">" +
                c.label +
                "</a></li>"
              );
            })
            .join("") +
          "</ul>";
      }

      return (
        '<li class="lyd-hv2-drawer__row"' +
        (hasKids ? ' data-has-subs' : "") +
        ">" +
        main +
        subs +
        "</li>"
      );
    }).join("");

    return (
      '<div class="lyd-hv2-drawer-backdrop" data-lyd-drawer-close hidden></div>' +
      '<aside class="lyd-hv2-drawer" id="lyd-hv2-drawer" role="dialog" aria-modal="true" aria-label="Menü" hidden>' +
      '<div class="lyd-hv2-drawer__head">' +
      '<p class="lyd-hv2-drawer__title">Menü</p>' +
      '<button type="button" class="lyd-hv2-drawer__close" data-lyd-drawer-close aria-label="Menü schließen">' +
      svg('<path d="M18 6L6 18"/><path d="M6 6l12 12"/>') +
      "</button>" +
      "</div>" +
      '<div class="lyd-hv2-drawer__body">' +
      '<ul class="lyd-hv2-drawer__list">' +
      rows +
      "</ul>" +
      "</div>" +
      '<div class="lyd-hv2-drawer__foot">' +
      '<a href="/search">' +
      svg('<circle cx="11" cy="11" r="8"/><path d="M21 21l-4.35-4.35"/>') +
      "Suche</a>" +
      '<a href="/account/login">' +
      svg(
        '<path d="M20 21v-2a4 4 0 0 0-4-4H8a4 4 0 0 0-4 4v2"/><circle cx="12" cy="7" r="4"/>'
      ) +
      "Konto</a>" +
      '<a href="/cart" data-no-instant>' +
      svg(
        '<path d="M6 2L3 6v14a2 2 0 0 0 2 2h14a2 2 0 0 0 2-2V6l-3-4z"/><path d="M3 6h18"/><path d="M16 10a4 4 0 0 1-8 0"/>'
      ) +
      "Warenkorb</a>" +
      "</div>" +
      "</aside>"
    );
  }

  function wireDropdowns(root) {
    var items = root.querySelectorAll(
      ".lyd-hv2-siteheader__item[data-has-panel]"
    );
    var openTimer = null;
    var closeTimer = null;
    var openItem = null;

    function setExpanded(item, open) {
      var link = item.querySelector(".lyd-hv2-siteheader__link");
      if (link) link.setAttribute("aria-expanded", open ? "true" : "false");
      if (open) item.classList.add("is-open");
      else item.classList.remove("is-open");
    }

    function closeAll(except) {
      items.forEach(function (it) {
        if (it !== except) setExpanded(it, false);
      });
      if (!except) openItem = null;
    }

    function scheduleOpen(item) {
      clearTimeout(closeTimer);
      clearTimeout(openTimer);
      openTimer = setTimeout(function () {
        closeAll(item);
        setExpanded(item, true);
        openItem = item;
      }, OPEN_DELAY);
    }

    function scheduleClose(item) {
      clearTimeout(openTimer);
      clearTimeout(closeTimer);
      closeTimer = setTimeout(function () {
        if (openItem === item) {
          setExpanded(item, false);
          openItem = null;
        }
      }, CLOSE_DELAY);
    }

    items.forEach(function (item) {
      item.addEventListener("mouseenter", function () {
        scheduleOpen(item);
      });
      item.addEventListener("mouseleave", function () {
        scheduleClose(item);
      });
      item.addEventListener("focusin", function () {
        clearTimeout(closeTimer);
        closeAll(item);
        setExpanded(item, true);
        openItem = item;
      });
      item.addEventListener("focusout", function (e) {
        if (!item.contains(e.relatedTarget)) {
          scheduleClose(item);
        }
      });
    });

    document.addEventListener("keydown", function (e) {
      if (e.key === "Escape" && openItem) {
        setExpanded(openItem, false);
        var link = openItem.querySelector(".lyd-hv2-siteheader__link");
        openItem = null;
        if (link) link.focus();
      }
    });

    document.addEventListener(
      "click",
      function (e) {
        if (!openItem) return;
        if (!openItem.contains(e.target)) {
          setExpanded(openItem, false);
          openItem = null;
        }
      },
      true
    );
  }

  function wireMobileDrawer(root) {
    var burger = root.querySelector("[data-lyd-drawer-open]");
    var drawer = root.querySelector("#lyd-hv2-drawer");
    var backdrop = root.querySelector(".lyd-hv2-drawer-backdrop");
    if (!burger || !drawer) return;

    var lastFocus = null;

    function setOpen(open) {
      if (open) {
        lastFocus = document.activeElement;
        document.body.classList.add("lyd-hv2-nav-open");
        drawer.hidden = false;
        if (backdrop) backdrop.hidden = false;
        burger.setAttribute("aria-expanded", "true");
        // focus close after paint
        requestAnimationFrame(function () {
          var closeBtn = drawer.querySelector("[data-lyd-drawer-close]");
          if (closeBtn) closeBtn.focus();
        });
      } else {
        document.body.classList.remove("lyd-hv2-nav-open");
        burger.setAttribute("aria-expanded", "false");
        // allow transition then hide for a11y
        setTimeout(function () {
          if (!document.body.classList.contains("lyd-hv2-nav-open")) {
            drawer.hidden = true;
            if (backdrop) backdrop.hidden = true;
          }
        }, 280);
        if (lastFocus && lastFocus.focus) lastFocus.focus();
      }
    }

    burger.addEventListener("click", function () {
      var isOpen = document.body.classList.contains("lyd-hv2-nav-open");
      setOpen(!isOpen);
    });

    root.querySelectorAll("[data-lyd-drawer-close]").forEach(function (el) {
      el.addEventListener("click", function () {
        setOpen(false);
      });
    });

    // Accordion toggles
    drawer.querySelectorAll(".lyd-hv2-drawer__row[data-has-subs]").forEach(function (row) {
      var btn = row.querySelector(".lyd-hv2-drawer__toggle");
      var subs = row.querySelector(".lyd-hv2-drawer__subs");
      if (!btn || !subs) return;
      btn.addEventListener("click", function () {
        var open = !row.classList.contains("is-open");
        // close siblings (optional single-open)
        drawer.querySelectorAll(".lyd-hv2-drawer__row.is-open").forEach(function (other) {
          if (other !== row) {
            other.classList.remove("is-open");
            var ob = other.querySelector(".lyd-hv2-drawer__toggle");
            var os = other.querySelector(".lyd-hv2-drawer__subs");
            if (ob) ob.setAttribute("aria-expanded", "false");
            if (os) os.hidden = true;
          }
        });
        row.classList.toggle("is-open", open);
        btn.setAttribute("aria-expanded", open ? "true" : "false");
        subs.hidden = !open;
      });
    });

    document.addEventListener("keydown", function (e) {
      if (e.key === "Escape" && document.body.classList.contains("lyd-hv2-nav-open")) {
        setOpen(false);
      }
    });

    // Close if resizing to desktop
    var mq = window.matchMedia("(min-width: 901px)");
    function onMq(e) {
      if (e.matches) setOpen(false);
    }
    if (mq.addEventListener) mq.addEventListener("change", onMq);
    else if (mq.addListener) mq.addListener(onMq);
  }

  function buildChrome() {
    if (document.getElementById(ROOT_ID)) return;

    var root = document.createElement("div");
    root.id = ROOT_ID;
    root.className = "lyd-hv2-chrome-root";

    var trustItems = [
      {
        icon: '<path d="M20 6L9 17l-5-5"/>',
        text: "Über 300.000 Kunden",
      },
      {
        icon:
          '<rect x="1" y="6" width="15" height="12" rx="2"/><path d="M16 10h4l3 3v5h-7"/><circle cx="6" cy="18" r="1.6"/><circle cx="19" cy="18" r="1.6"/>',
        text: "Versandkostenfrei ab 50 €",
      },
      {
        icon: '<path d="M12 2l2.9 6.9L22 9.2l-5 4.9 1.2 7L12 17.8 5.8 21.1 7 14.1 2 9.2l7.1-.3L12 2z" fill="currentColor" stroke="none"/>',
        text: "9.601 Bewertungen · Ø 4,9 · Okendo",
      },
      {
        icon: '<path d="M22 16.92v3a2 2 0 0 1-2.18 2 19.79 19.79 0 0 1-8.63-3.07 19.5 19.5 0 0 1-6-6 19.79 19.79 0 0 1-3.07-8.67A2 2 0 0 1 4.11 2h3a2 2 0 0 1 2 1.72c.127.96.361 1.903.7 2.81a2 2 0 0 1-.45 2.11L8.09 9.91a16 16 0 0 0 6 6l1.27-1.27a2 2 0 0 1 2.11-.45c.907.339 1.85.573 2.81.7A2 2 0 0 1 22 16.92z"/>',
        text: "030 568 380 65",
      },
    ];

    var trustHtml =
      '<div class="lyd-hv2-trustbar" id="lyd-hv2-trustbar" role="region" aria-label="Shop-Vorteile">' +
      '<div class="lyd-hv2-trustbar__inner">' +
      trustItems
        .map(function (it) {
          return (
            '<span class="lyd-hv2-trustbar__item">' +
            svg(it.icon) +
            it.text +
            "</span>"
          );
        })
        .join("") +
      "</div></div>";

    var navHtml = NAV.map(navItemHtml).join("");

    var icons =
      '<div class="lyd-hv2-siteheader__icons">' +
      '<a href="/search" aria-label="Suche">' +
      svg('<circle cx="11" cy="11" r="8"/><path d="M21 21l-4.35-4.35"/>') +
      "</a>" +
      '<a href="/account/login" aria-label="Konto">' +
      svg(
        '<path d="M20 21v-2a4 4 0 0 0-4-4H8a4 4 0 0 0-4 4v2"/><circle cx="12" cy="7" r="4"/>'
      ) +
      "</a>" +
      '<a href="/cart" aria-label="Warenkorb" data-no-instant>' +
      svg(
        '<path d="M6 2L3 6v14a2 2 0 0 0 2 2h14a2 2 0 0 0 2-2V6l-3-4z"/><path d="M3 6h18"/><path d="M16 10a4 4 0 0 1-8 0"/>'
      ) +
      "</a>" +
      "</div>";

    var burger =
      '<button type="button" class="lyd-hv2-siteheader__burger" data-lyd-drawer-open aria-expanded="false" aria-controls="lyd-hv2-drawer" aria-label="Menü öffnen">' +
      '<span class="lyd-hv2-siteheader__burger-icon" aria-hidden="true"></span>' +
      "</button>";

    var headerHtml =
      '<header class="lyd-hv2-siteheader" role="banner">' +
      '<div class="lyd-hv2-siteheader__wrap">' +
      burger +
      logoHtml() +
      '<nav class="lyd-hv2-siteheader__nav" aria-label="Hauptnavigation">' +
      navHtml +
      "</nav>" +
      icons +
      "</div></header>";

    root.innerHTML = trustHtml + headerHtml + drawerHtml();

    if (document.body) {
      document.body.insertBefore(root, document.body.firstChild);
    }

    wireDropdowns(root);
    wireMobileDrawer(root);
  }

  /**
   * Mockup footer (home.html) — replaces Impact footer group on DEV.
   * Link targets use real shop paths; menus stay hardcoded until dynamic nav.
   */
  function buildFooter() {
    if (document.getElementById("lyd-hv2-footer")) return;
    if (!document.body) return;

    var year = new Date().getFullYear();
    var footer = document.createElement("footer");
    footer.id = "lyd-hv2-footer";
    footer.className = "lyd-hv2-footer";
    footer.setAttribute("role", "contentinfo");
    footer.innerHTML =
      '<div class="lyd-hv2-footer__wrap lyd-hv2-footer__cols">' +
      "<div>" +
      '<div class="lyd-hv2-footer__logo">LYNDEN</div>' +
      '<p class="lyd-hv2-footer__about">' +
      "Premium E-Zigaretten, Liquids und Depots. Deutsche Marke mit Sitz in Berlin — seit über 10 Jahren. Beratung: " +
      '<a href="tel:+493056838065" style="display:inline;color:inherit;text-decoration:underline">030 568 380 65</a>' +
      "</p>" +
      "</div>" +
      "<div>" +
      "<h4>Über uns</h4>" +
      '<a href="/pages/ueber-uns">Über LYNDEN</a>' +
      '<a href="/pages/versand-zahlungsinformationen">Versand &amp; Zahlung</a>' +
      '<a href="/pages/kontakt">Kontakt</a>' +
      '<a href="/pages/presse">Presse</a>' +
      "</div>" +
      "<div>" +
      "<h4>Informationen</h4>" +
      '<a href="/pages/liquid-rechner">Liquid-Rechner</a>' +
      '<a href="/blogs/e-zigaretten-blog">E-Zigaretten Blog</a>' +
      '<a href="/pages/faq">FAQ</a>' +
      '<a href="/pages/glossar">Glossar</a>' +
      '<a href="/pages/recycling">Recycling</a>' +
      "</div>" +
      "<div>" +
      "<h4>Newsletter</h4>" +
      '<p class="lyd-hv2-footer__news-note">Neuheiten &amp; Angebote — kein Spam.</p>' +
      '<a href="/#lyd-home-og-hub" style="margin-top:10px">Zum Newsletter</a>' +
      "</div>" +
      "</div>" +
      '<div class="lyd-hv2-footer__sub">' +
      '<div class="lyd-hv2-footer__wrap">' +
      "© " +
      year +
      " LYNDEN" +
      ' · <a href="/policies/privacy-policy">Datenschutz</a>' +
      ' · <a href="/policies/legal-notice">Impressum</a>' +
      ' · <a href="/policies/terms-of-service">AGB</a>' +
      ' · <a href="/policies/refund-policy">Widerruf</a>' +
      "</div></div>";

    document.body.appendChild(footer);
  }

  function boot() {
    mark();
    buildChrome();
    buildFooter();
    hideImpactChrome();
  }

  mark();
  ready(boot);
  document.addEventListener("shopify:section:load", boot);
})();
